export default __webpack_public_path__ + "static/media/kitten4S.2af8fe31.webp";